import type { ZodiosPlugin } from '@zodios/core'

/**
 * Zodios substitutes `:path` params with raw string interpolation (no encoding).
 * Register on a Zodios client so call sites can pass raw IDs containing `/`, spaces,
 * or other reserved characters without encoding at each call site.
 */
export const encodePathParamsPlugin: ZodiosPlugin = {
  name: 'encode-path-params',
  request: async (_api, config) => {
    const { params } = config
    if (!params) return config

    return {
      ...config,
      params: Object.fromEntries(
        Object.entries(params).map(([key, value]) => [key, encodeURIComponent(String(value))]),
      ),
    }
  },
}
